<template>
  <div class="payment-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :initialSearchFilter="initialSearchFilter"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">
      <ui-button :color="'gray'"
                 @click="isShowCalculator = true">
         종량제 계산기
      </ui-button>
      <ui-button :color="'green'"
                 @click="toggleInsert">
        <i class="xi-plus"></i> 플랜 적용
      </ui-button>
      <ui-button :color="'green'"
                 @click="toggleInsertPv">
        <i class="xi-battery-o"></i> PV 충전
      </ui-button>
      <ui-button :color="'purple'"
                 @click="toggleExcel(true)">
        <i class="xi-view-list"></i> 엑셀 다운로드
      </ui-button>
    </template-search-list>

    <template-insert :show="show.insert"
                     :metaApi="insertMetaApi"
                     :insertApi="insertApi"
                     :service="'ba'"
                     @reload="reloadList"
                     @saved="reloadList"
                     @close="toggleInsert" :menu="'plan'">
      <h4 class="title"><i class="bi-ba"></i> 플랜 적용</h4>
    </template-insert>

    <template-insert :show="show.insertPv"
                     :metaApi="insertPvMetaApi"
                     :insertApi="insertPvApi"
                     :menu="'chargePV'"
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleInsertPv">
      <h4 class="title"><i class="bi-ba"></i> PV 충전</h4>
    </template-insert>

    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :service="'ba'"
                     :removeApi="removeApi"
                     :apiParam="apiParam"
                     @reload="reloadList"
                     @close="setSelected">
    </template-detail>

    <excel-column-select :excelDownload="excelDownload"
                         :metaApi="excelListMetaApi"
                         :listApi="listApi"
                         :searchFilter="searchFilter"
                         @export="excelExport"
                         @close="toggleExcel(false)"/>
    
    <postpaid-calculator :show="isShowCalculator" @close="isShowCalculator = false"/>
  </div>
</template>

<script>
import {
  getBaPaymentList,
  getBaPaymentInfo,
  updateBaPayment,
  insertBaPayment,
  getBaPaymentInsertMeta,
  removeBaPayment,
  getBaPaymentExcelMeta
} from '@/api/plan'
import { getBaCreditInsertMeta, insertBaCredit } from '@/api/credit'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'
import TemplateInsert from '@/components/_template/Insert'
import UiButton from '@/components/_ui/UiButton'

import Excel from '@/utils/excel-export'
import ExcelColumnSelect from '@/components/_template/ExcelColumnSelect'
import { EventBus } from '@/utils/event-bus'
import { STORAGE_ITEM } from '@/utils/constants'
import PostpaidCalculator from "@/components/plan/ba/PostpaidCalculator.vue";

export default {
  name: 'BaPlanList',
  components: {
    PostpaidCalculator,
    ExcelColumnSelect,
    TemplateSearchList,
    TemplateDetail,
    TemplateInsert,
    UiButton
  },
  created () {
    // console.log('eventbus: ', EventBus.$on('searchData', this.apiParam))
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.userId) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.userId = searchData.userId
        this.initialSearchFilter.userIdExact = true
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data._id }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    toggleInsertPv (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insertPv = !this.show.insertPv
      } else {
        this.show.insertPv = value
      }
    },
    toggleExcel (value = false) {
      this.excelDownload = value
    },
    excelExport (col, data, selectCol) {
      const fileName = 'eagle_ba_plan'
      const excel = new Excel()
      EventBus.$emit('onLoading', true)
      excel.setExcelData('planBa', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        }).catch(e => {
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    setSelected (row) {
      this.selected = row
    },
  },
  data () {
    return {
      isShowCalculator: false,
      reload: 0,
      selected: null,
      infoApi: getBaPaymentInfo,
      editApi: updateBaPayment,
      removeApi: removeBaPayment,
      insertApi: insertBaPayment,
      insertMetaApi: getBaPaymentInsertMeta,
      insertPvApi: insertBaCredit,
      insertPvMetaApi: getBaCreditInsertMeta,
      apiParam: null,

      listApi: getBaPaymentList,
      excelListMetaApi: getBaPaymentExcelMeta,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',

      show: {
        insert: false,
        insertPv: false
      },
      excelDownload: false,
      searchFilter: {},
      initialSearchFilter: null
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-list-wrap {
}
</style>
